package org.zq.astrock_ai.util

import kotlin.math.abs
import kotlin.math.pow
import kotlin.math.round

/**
 * 跨平台数字格式化（替代 JVM 专用的 String.format）。
 */
fun formatDecimal(
    value: Double,
    digits: Int = 2,
    forceSign: Boolean = false,
): String {
    require(digits >= 0)
    val factor = 10.0.pow(digits)
    val divisor = factor.toLong().coerceAtLeast(1L)
    val scaled = round(abs(value) * factor).toLong()
    val whole = scaled / divisor
    val frac = scaled % divisor
    val body = if (digits == 0) {
        whole.toString()
    } else {
        "$whole.${frac.toString().padStart(digits, '0')}"
    }
    val sign = when {
        scaled == 0L -> if (forceSign) "+" else ""
        value < 0.0 -> "-"
        forceSign -> "+"
        else -> ""
    }
    return sign + body
}
